import { DateTime } from 'luxon';

/**
 * This function converts a Unix timestamp to a formatted date/time string.
 * @param timestamp The unix timestamp in milliseconds
 * @param dateFormat The date time format string to string e.g 'hh:mm a, MMM d'; 'h:mm a'.
 * @returns The formatted date time string, or null if the input timestamp is invalid. 
 */
export const convertUnixTimeStampToDate = (timestamp: number, format: string): string | null => {
    try {
        const dateTimeFromTS = DateTime.fromMillis(timestamp);
        const formattedDateTimeStr = dateTimeFromTS.toFormat(format);
        return formattedDateTimeStr;
    } catch (error) {
        console.error('Error converting Unix timestamp to formatted date time string ---> ', error);
        return null;
    }
};